// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"city-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M11 11H21V21H3V3H11V11Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 21V16H17V21H21Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7.00391 7V7.00391H7M7.00391 12V12.0039H7M7.00391 17V17.0039H7M21 16V21H17V16H21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11 21H3V3H11V11M11 21V11M11 21H21V11H11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const City1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-1',
    ref,
    icon: element,
  },
));

City1Icon.displayName = 'City1Icon';

export default City1Icon;
